import React from "react";
import nf from "../../assets/image.jpg";
function Collection() {
  return (
    <div>
      <div className="container " style={{ marginTop: "12%" }}>
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 ">
            <h1 className="fw-bold text-white" style={{ fontSize: "60px" }}>
              The Marthy NFT collection
            </h1>
            <p className="text-white">
              Marthy is Phili’s best buddy and he is here to help Phili in his
              quest to dominate the Flare blockchain. The Marthy collection
              consists of fully customizable PFP NFTs giving every holder the
              ultimate freedom to customize their NFT from millions of
              combinations.
            </p>
          </div>
          <div className="col-12 col-lg-6 m-auto">
            <div className=" d-flex justify-content-center ">
              <div
                className="card  "
                style={{
                  width: "22rem",
                  backgroundColor: "#ffbca2",
                  borderRadius: "14px",
                }}
              >
                <div className="card-body">
                  <img src={nf} className="imgnft" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collection;
